<template>
  <div class="calico-story-card">
    <div class="icon-container">
      <i
        v-if="Number(String(score).replace('%','')).toFixed(0) > 0"
        class="bi bi-caret-up-fill contained-icon-xsmall"
      />
      <i
        v-else-if="Number(String(score).replace('%','')).toFixed(0) < 0"
        class="bi bi-caret-down-fill contained-icon-xsmall"
      />
      <i
        v-else
        class="bi bi-dash-lg contained-icon-xsmall"
      />
    </div>
    <div class="content">
      <label class="label--medium">
        {{ title }}
      </label>
      <p class="body--small">
        {{ description }}
      </p>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "CalicoStoryCard",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      default: 0
    }
  },
};
</script>
    
<style scoped lang="scss">
.calico-story-card {
    @include inline-space($space-medium);
    .content {
      @include stack-space($space-xsmall);
      label, p {
          margin: 0;
      }
    }
    .icon-container {
      .bi-caret-up-fill {
        background-color: $color-green;
        border: 0;
      }
      .bi-caret-down-fill {
        background-color: $color-orange-light;
        border: 0;
      }
      .bi-dash-lg {
        background-color: $color-neutral;
        border: 0;
      }

    }
}
</style>